
import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './podcast.css'
import BreadCrumb from '../../main/components/BreadCrumb';
import PodcastCard from './PodcastCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import img from "../../assets/video/unsplash_50GSjnC7qXw.png"
const Podcast = () => {
    const [podcastDoc,setPodcastDoc] = useState(null);

    useEffect(() => {
        client
            .query({
                query: queries.podCast,
            })
            .then((response) => {
                const podcastInfo = response.data.allPodcasts.edges[0].node;
                setPodcastDoc(podcastInfo);
                window.scrollTo(0, 0);
            })
            .catch((error) => {
                console.error(error);
            });
            
    });
    return (
        <section style={{ backgroundImage: 'url(' + podcastDoc?.section_bg?.url + ')' }} className="pattern chart-container">
            <div className="container">
                <BreadCrumb nested={"Events & Podcasts"} />
                <h3 className="subtitle ">{podcastDoc?.title}</h3>
                <div className="top-podcast-banner ">
                    <div className="card all-podcast-card   mb-3">
                        <div className="row g-0">
                            <div className="col-md-3 col-3 p-md-4 p-2">
                                <img src={img} className=" rounded-3 h-100  img-fluid" alt="..."></img>
                            </div>
                            <div className="col-md-9 col-9 ">
                                <div className="card-body pb-0 d-flex flex-column justify-content-center ">
                                    <div className="  author-text">
                                        <small className="secondary-text">Artificial Intelligence <span className="ms-2">45 Mins</span></small>
                                    </div>
                                    <div className=" text-content">
                                        <h5 className="m-0 pt-3" >The Revolutionary A.I.</h5>
                                        <small className="secondary-text fw-bold d-block d-md-none">Avinash Kumar, Arun Dubey </small>

                                        <p className="muted-text  d-none d-md-block"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi netus etiam libero id felis commodo enim. Condimentum aenean mattis nullam enim integer sem fames diam ipsum. Morbi tempor eget euismod tincidunt. Ipsum hendrerit massa duis purus etiam. </p>
                                        <div className="  author-text">
                                            <small className="secondary-text fw-bold">Avinash Kumar, Arun Dubey </small>
                                        </div>
                                        <a className="d-none d-md-block" href={""} >
                                            <button
                                                className="primary-btn my-3 px-4">
                                                <span className="me-2"><FontAwesomeIcon icon={faPlay} /></span> {"Play Episode"}</button>
                                        </a>
                                    </div>
                                    <div className="d-flex ply-btn d-block d-md-none justify-content-end pe-3 pinter-cursor  third-text">
                                        <div className="rounded-circle bg-light p-3">
                                            <FontAwesomeIcon icon={faPlay} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <small className="d-block d-md-none ms-2 mobile-footer">Artificial Intelligence <span className="mx-3 card-dot "></span> <span >45 Mins</span></small>
                        </div>
                    </div>
                </div>
                <h5 className="section-title py-3"> {"All Podcasts"}</h5>
                <div className="row g-0 ">
                    {podcastDoc?.allpodcast?.map((info, index) => <PodcastCard key={index + 1}  info={info} />)}
                </div>

            </div>

        </section>
    );
};

export default Podcast;